/**
 * Firestore services bound to CUKCUK-only collections.
 * Import CUKCUK must never write to iPOS collections (8am_*, invoice_notifications).
 */
import {
  CUKCUK_CUSTOMIZATION_COLLECTION,
  CUKCUK_DISHES_COLLECTION,
  CUKCUK_INVOICE_NOTIFICATIONS_COLLECTION,
} from '../constants/cukcuk';
import { CustomizationService } from './CustomizationService';
import { DishService } from './dishService';
import { InvoiceNotificationService } from './invoiceNotificationService';

export const createCukcukDishService = (): DishService =>
  new DishService(CUKCUK_DISHES_COLLECTION);

export const createCukcukCustomizationService = (): CustomizationService =>
  new CustomizationService(CUKCUK_CUSTOMIZATION_COLLECTION);

export const createCukcukInvoiceNotificationService = (): InvoiceNotificationService =>
  new InvoiceNotificationService(CUKCUK_INVOICE_NOTIFICATIONS_COLLECTION);

export const cukcukDishService = createCukcukDishService();
export const cukcukCustomizationService = createCukcukCustomizationService();
export const cukcukInvoiceNotificationService = createCukcukInvoiceNotificationService();
